module.exports = __webpack_public_path__ + "static/media/Lato-Black.21c4d25c.woff";